import { Adjustments } from "../../model/adjustment";
import { Action, ActionType } from "../../model/actionTypes";
import createReducer from "./createReducer";

export const adjustments = createReducer<Adjustments>({statusCode: 200 }, {
	[ActionType.ACKNOLEGDEMENT](state: Adjustments, action: Action<Adjustments>) {
		return action.payload;
	}
});
